<template lang="pug">
.doESSAYQUESTION
  .cont  {{cont.stem}}
  .hint {{cont.hint}}
  //- textarea(v-model="item.option",:disabled='cont.isShow||Completed').textarea
  Input(v-model="item.option" maxlength="500" :rows="4" show-word-limit type="textarea" :disabled='cont.isShow||Completed').textarea1
</template>

<script>
export default {
  props: ["cont", "HistoryData"],
  data() {
    return {
      Completed: sessionStorage.getItem("Completed") === "true",
      item: {
        option: ""
      },
      id: false
    };
  },
  created() {
    console.log(this.Completed);
    if (this.cont.isShow) {
      this.item.option = this.cont.metas;
    }
    if (this.HistoryData) {
      this.item.option = this.HistoryData.questionAnswer;
      this.id = this.HistoryData.id;
    }
  }
};
</script>

<style lang="stylus" scoped>
.doESSAYQUESTION
  width 100%
  .cont
    font-size 16px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 1)
    line-height 20px
  .hint
    margin-bottom 8px
    color #7b7272
  .textarea
    width 796px
    height 100px
    background rgba(255, 255, 255, 1)
    border-radius 4px
    border 1px solid rgba(210, 221, 236, 1)
    outline none
    padding 10px
    resize none
  .textarea1
    margin-top 5px
</style>
